import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { extendCommonGroupsStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../../contexts/stylesheet.js";
const Group = ({ headline, borderless, children, legend, ...rest })=>{
    const { Group, GroupInner, GroupDescription, screenReaderOnlyClass } = useStylesheet().extend(...extendCommonGroupsStylesheet);
    const useLegend = legend ? legend : typeof headline === "string" ? headline : undefined;
    const inner = /*#__PURE__*/ _jsxs(GroupInner, {
        children: [
            typeof headline === "string" ? /*#__PURE__*/ _jsx("legend", {
                children: headline
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    useLegend && /*#__PURE__*/ _jsx("legend", {
                        className: screenReaderOnlyClass,
                        children: useLegend
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: headline
                    })
                ]
            }),
            children && /*#__PURE__*/ _jsx(GroupDescription, {
                children: children
            })
        ]
    });
    return borderless ? /*#__PURE__*/ _jsx("div", {
        className: "group",
        ...rest,
        children: inner
    }) : /*#__PURE__*/ _jsx(Group, {
        ...rest,
        children: inner
    });
};
export { Group };
